module.exports = __webpack_public_path__ + "static/img/anslysis3.3a6db14b.png";